import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getResourcecategories } from '../../../../../redux/actions/resourcecategories'
import { filterResources } from '../../../../../redux/actions/resources'
import { getResourcetypes } from '../../../../../redux/actions/resourcetypes'
import { getTags } from '../../../../../redux/actions/tags'
import { IRootState } from '../../../../../redux/types'

interface IFilter {
  resourcetype_id: null | number
  category_id: null | number
  family_id: null | number
  brand_id: null | number
  line_id: null | number
  country_id: null | number
  role_id: null | number
  countries: number[]
  filterBy: any
}

export default function useResourceFilters() {
  const dispatch = useDispatch()
  const { t } = useTranslation(['global'])

  const { globalFamilyId, globalBrandId, globalCountriesId, globalLanguageId, globalLineId } = useSelector(
    (state: IRootState) => state.global
  )
  const { tags } = useSelector((state: IRootState) => state.tag)

  const [filters, setFilters] = useState<IFilter>({
    resourcetype_id: null,
    category_id: null,
    family_id: null,
    brand_id: null,
    line_id: null,
    country_id: null,
    role_id: null,
    countries: [],
    filterBy: []
  })

  const visibility = [
    { id: 0, name: t('private') },
    { id: 1, name: 'VIP' },
    { id: 2, name: t('public') },
    { id: 3, name: t('preregistration') }
  ]

  const optionsData = [
    { data: visibility, code: 'visibility', column: 'visibility' },
    { data: tags, code: 'categories', column: 'resource_tag.tag_id' }
  ]

  const handleClearFilters = () => {
    setFilters({ ...filters, resourcetype_id: null, category_id: null })
  }

  const handleChangeFilter = (resourcetype_id: number, category_id: null | number) => {
    setFilters({ ...filters, resourcetype_id, category_id })
  }

  useEffect(() => {
    setFilters({
      ...filters,
      family_id: globalFamilyId,
      brand_id: globalBrandId,
      line_id: globalLineId,
      countries: globalCountriesId
    })
  }, [globalFamilyId, globalBrandId, globalLineId, globalCountriesId])

  useEffect(() => {
    if (filters.countries.length > 0) dispatch(filterResources(filters))
  }, [filters])

  useEffect(() => {
    if (globalLanguageId !== null) dispatch(getResourcetypes())
  }, [globalLanguageId])

  useEffect(() => {
    if (globalLanguageId !== null) dispatch(getTags())
  }, [globalFamilyId, globalLanguageId])

  useEffect(() => {
    if (globalCountriesId !== null && globalLanguageId !== null) {
      dispatch(
        getResourcecategories({
          languageId: globalLanguageId,
          countriesId: globalCountriesId,
          familyId: globalFamilyId,
          brandId: globalBrandId
        })
      )
    }
  }, [globalCountriesId, globalFamilyId, globalBrandId, globalLanguageId])

  return { filters, setFilters, optionsData, handleChangeFilter, handleClearFilters }
}
